
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Shield } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface UserManagementSectionProps {
  settings: {
    userRegistration: boolean;
    requireKYC: boolean;
    autoApproveListings: boolean;
  };
  updateSetting: (key: string, value: any) => void;
}

const UserManagementSection = ({ settings, updateSetting }: UserManagementSectionProps) => {
  const { t } = useLanguage();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Shield className="h-5 w-5" />
          {t('user_management', 'إدارة المستخدمين', 'User Management')}
        </CardTitle>
        <CardDescription>
          {t('user_registration_settings', 'إعدادات تسجيل المستخدمين', 'User registration and verification settings')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>{t('user_registration', 'تسجيل المستخدمين', 'User Registration')}</Label>
            <p className="text-sm text-muted-foreground">
              {t('allow_new_registrations', 'السماح بالتسجيلات الجديدة', 'Allow new user registrations')}
            </p>
          </div>
          <Switch
            checked={settings.userRegistration}
            onCheckedChange={(checked) => updateSetting('userRegistration', checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>{t('require_kyc', 'طلب التحقق من الهوية', 'Require KYC')}</Label>
            <p className="text-sm text-muted-foreground">
              {t('require_kyc_desc', 'طلب التحقق من الهوية للمستخدمين الجدد', 'Require identity verification for new users')}
            </p>
          </div>
          <Switch
            checked={settings.requireKYC}
            onCheckedChange={(checked) => updateSetting('requireKYC', checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>{t('auto_approve_listings', 'الموافقة التلقائية على الإعلانات', 'Auto-approve Listings')}</Label>
            <p className="text-sm text-muted-foreground">
              {t('auto_approve_desc', 'الموافقة التلقائية على الإعلانات الجديدة', 'Automatically approve new property listings')}
            </p>
          </div>
          <Switch
            checked={settings.autoApproveListings}
            onCheckedChange={(checked) => updateSetting('autoApproveListings', checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default UserManagementSection;
